document.querySelectorAll('[id^="Details-HeaderMenu"]').forEach((details) => {
  const summary = details.querySelector(':scope > summary');
  const wrapper = details.closest('header-menu') || details;

  // Take over the click for toggling — but only when the click didn't
  // land on the parent's own link (the <a> now wrapping the label
  // text). That link needs to navigate normally; only the rest of the
  // summary (the caret icon, empty space) should act as a pure toggle.
  summary.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      // Real navigation link — let the browser follow it as normal.
      return;
    }

    event.preventDefault();
    const isOpen = details.hasAttribute('open');
    if (isOpen) {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    } else {
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  });

  wrapper.addEventListener('mouseenter', () => {
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  wrapper.addEventListener('mouseleave', () => {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('click', (event) => {
    if (wrapper.contains(event.target)) return;
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
  });
});